import React from "react";
import ImageGallery from "../components/ImageGallery";

function ShootingPage() {
  return <ImageGallery category="shooting" />;
}

export default ShootingPage;
